import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { UserRole, UsersService } from '../users.service'
import { filter, map, take } from 'rxjs'

export function createRoleGuard(hasAccess: (role: UserRole | undefined) => boolean): CanActivateFn {
  return () => {
    const usersService = inject(UsersService)
    const router = inject(Router)

    return usersService.getCurrentUser().pipe(
      // Wait for a settled result: an in-flight refetch still carries the cached role, so authorizing
      // on it could pass stale access (e.g. just after a demotion) until the fresh response lands.
      filter((result) => (result.isSuccess && !result.isFetching) || result.isError),
      take(1),
      // Fail closed: a refetch error (e.g. after logout or demotion) must not authorize on stale role data.
      map((result) => (result.isSuccess && hasAccess(result.data?.role) ? true : router.createUrlTree(['/app'])))
    )
  }
}
